// @flow
import { createAction } from 'redux-actions';

export const mountCollection = createAction(
  'MOUNT_CHANNEL_COLLECTION',
  (channelName: string) => channelName
);

export const unmountCollection = createAction(
  'UNMOUNT_CHANNEL_COLLECTION',
  (channelName: string) => channelName
);

export const requestChannelContent = createAction(
  'REQUEST_CHANNEL_CONTENT',
  (apiMethod: string => void, channelName: string, endDateTime?: string) => ({
    apiMethod,
    channelName,
    endDateTime,
  })
);

export const receiveChannelContent = createAction(
  'RECEIVE_CHANNEL_CONTENT',
  (channelName: string, items: Array<UgcId>) => items,
  (channelName: string, items: Array<UgcId>) => channelName
);



// WEBPACK FOOTER //
// ./src/containers/channels/ducks/channelContentActions.js